import useSWR from "swr";
import { fetchNotification } from "@dev-togetherprice/api.services";
export const useNotificationSummary = () => useSWR("/notificationsSummary", fetchNotification, {
    suspense: false,
    dedupingInterval: 3000,
    refreshInterval: 30000,
    revalidateOnMount: true,
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
}).data;
